import { Semantics } from "shared/components/drops/DropsBadge";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import styled from "styled-components";

const Indicator = styled.div<{
  $fill: string;
  $outline: string;
}>`
  width: 20px;
  height: 20px;
  background-color: ${({ $fill }) => $fill};
  border-radius: 100%;
  border: solid 6px ${({ $outline }) => $outline};
`;

export const VisibilityIndicator = ({
  semantics,
}: {
  semantics: Semantics;
}) => {
  const theme = useThemeSemantic(semantics);
  return (
    <Indicator $fill={theme.colorSemantic} $outline={theme.colorSemanticFill} />
  );
};
